import type { RouterChildContext } from 'react-router-dom';
import type { BrandType } from '../common/types/queries/currentUserForLayoutQuery/models';
import { routes } from '../constants/routesAndApisConstants';

export const redirectToActualUrl = (
  brand: BrandType,
  history: RouterChildContext['router']['history'],
  actualUrl: string,
  orderBrandCode?: string | null,
  orderBrandName?: string | null,
) => {
  if (brand.code.toLowerCase() === orderBrandCode?.toLowerCase()) {
    const redirectUrl = new URL(actualUrl);
    const storedUtmParams = sessionStorage.getItem('ibe.siteContext.utmParams');
    if (storedUtmParams) {
      new URLSearchParams(storedUtmParams).forEach((value, key) => {
        if (!redirectUrl.searchParams.has(key)) {
          redirectUrl.searchParams.set(key, value);
        }
      });
    }
    window.location.assign(redirectUrl.toString());
  } else {
    history.push(routes.NEW_BRAND_REDIRECTION, {
      brand: {
        code: orderBrandCode,
        name: orderBrandName,
        url: actualUrl,
      },
      redirectionType: 'order-login',
    });
  }
};
